import { z } from 'zod'

import { AttributionSourceType } from '../constants/attributionSource'
import { listQueryZodFields } from './system'
import { dbEntitySchema } from './system'

export const attributionSourceSchema = dbEntitySchema.extend({
  name: z.string(),
  type: z.nativeEnum(AttributionSourceType),
  value: z.string(),
  organization: z.string(),
  importId: z.string().optional(),
})

export const attributionSourceListQuerySchema = z.object({
  ...listQueryZodFields,
  type: z.nativeEnum(AttributionSourceType).optional(),
  search: z.string().optional(),
})

export const attributionSourceListResponseSchema = z.object({
  data: z.array(attributionSourceSchema),
  count: z.number(),
})

export const attributionSourceCreateArgsSchema = z.object({
  organizationId: z.string(),
  name: z.string().trim().min(1),
  importId: z.string().optional(),
})

export const attributionSourceUpdateByIdArgsSchema = z.object({
  name: z.string().trim().min(1),
})

export const attributionSourceMergeByIdArgsSchema = z.object({
  organizationId: z.string(),
  toId: z.string(),
  fromIds: z.array(z.string()),
})
